import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig } from '@spartacus/core';
import { ProductDescriptionClassificationComponent } from './product-description-classification.component';

@NgModule({
  declarations: [ProductDescriptionClassificationComponent],
  imports: [CommonModule, MatIconModule, MatExpansionModule, I18nModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductDescriptionComponent: {
          component: ProductDescriptionClassificationComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
  exports: [ProductDescriptionClassificationComponent],
})
export class ProductDescriptionClassificationModule {}
